import React, { useContext } from 'react';
import { UNITY_REF } from '../../config/constant/projectConstant';
import { unitycontext } from '../../hooks/useUnityContext';
import { UnityContext } from 'react-unity-webgl';
import { useDispatch } from 'react-redux';
import {
  curatorSelector,
  selectAllOnboardingData,
  selectIsV1UploadedProject,
  selectSelectedOnboardingMaterial,
  selectSelectedOnboardingProduct,
  setCuratorLoader,
  setObjectSelectionActive,
  setRoomLoadedCompletely,
  setSelectedOnboardingMaterial,
  setSelectedOnboardingOtherMaterial,
} from '../../redux/slicers/admin/curatorSlicer';
import {
  calculateSafeFrameSize,
  getPropLightList,
  getTextureFormat,
  getTextureSize,
  cmToUnitySize,
  isExclusiveProp,
  unitySizeToCM,
} from '../../helpers/unityHelper';
import {
  getMaterial,
  getTexture,
  updateDbLowTexture,
  updateDbMaterial,
  updateDbProp,
  updateDbTexture,
} from '../../helpers/idb';
import {
  selectCanvasFrameHeight,
  selectCanvasFrameWidth,
  selectCanvasSize,
  selectGlobalHeight,
  selectGlobalWidth,
  selectSafeFrameSize,
  setGlobalFov,
  setGlobalHeight,
  setGlobalSafeCameraFlag,
  setGlobalWidth,
} from '../../redux/slicers/camera/cameraSettings';
import { getAppState } from '../../redux/store';
import { errorToast } from '../../helpers/toastHelper';
import { pubSubState } from '../../helpers/unityPubSub';
import { addDefaultTexturesToObject } from '../../helpers/unity/addDefaultTexturesToObject';
import { undoRedo } from '../admin/curator/UndoRedo/UndoRedo';
import { dispatcher } from '../../helpers/projectHelper';
import {
  setDraggableProductImage,
  setOpenProductsAfterPlacement,
  setUnityDraggableProductData,
} from '../../redux/slicers/admin/curatorProductsSlicer';
import {
  selectDataByTilingType,
  selectSelectedObjectList,
} from '../../redux/slicers/admin/curatorUnityObjectSlicer';
import {
  CM_IN_ONE_INCHES,
  QUAILTY,
  QUAILTY_TO_DPR,
  QUALITY_ID_TO_QUALITY,
  TILING_TYPE,
} from '../../config/constant/unityConstants';
import { setDraggablePropLoading } from '../../redux/slicers/admin/curatorLoaderSlicer';
//import { captureException } from '@sentry/react';
import { clearUI, openSidebarSection } from '../../helpers/curatorActions';
import { CURATOR_MENU_SECTION } from '../../redux/slicers/admin/curatorMenuPreferencesSlicer';
import api, { getJson } from '../../helpers/axiosHelper';
import { decimals } from '../../helpers/jsHelper';
import axios from 'axios';
import {
  paginatedProductActions,
  paginatedProductSelectors,
} from '../../redux/slicers/admin/paginatedProductSlicer';
import { cancelDraggablePropUI } from '../../api/useUnityProp';
import { setGlobalDPR } from '../../redux/slicers/utilities/utilitiesSlicer';
import { selectGamificationTooltipData } from '../../redux/slicers/gamificationTooltipSlicer';
import { isUserOnboarding } from '../gamificationTooltip/helpers';
import { CONVERT_IN_INCHES, CURRENT_USER } from '../../constants/projectConstants';
import { LogCurator } from '../../helpers/logEvents';
import { setCuratorNotSaved } from '../../pages/admin/curator/curatorState';
import { applyTexture, updateMissingTexturesInDb } from '../Configurator/unity/objectPropertiesMethods';
import { debounce } from 'lodash';
import {
  GLASS_MATERIAL_ID,
  GLASS_MATERIAL_OPTION_NAME,
} from '../../constants/productConfiguratorConstants';
import { THUMBNAIL_PLACEHOLDER } from '../../constants/assetConstants';
import { configuratorUnityContext } from '../Configurator/unity/configurator.config';
import { isRetailAutomation } from '../Configurator/utils';
import { getTexturePathsForUnityNoChangedMap, isMattressBuilderPage } from '../admin/curator/ProductBuilderComponents/commonHelper';
import { apiGet, apiGetMaterials, apiGetTextureList } from '../../helpers/api';
import { productBuilderActions } from '../../redux/slicers/productBuilder/productBuilder.slicer';
import { OP_GET_MATERIAL_API } from '../../config/constant/apiConstant';
import { urlToBlobUrl } from '../RetailAutomation/common/moduleHelper';
import { isProductionUrl } from '../../helpers/urlHelper';

export const unityContext = new UnityContext(UNITY_REF);
window.unityContext = unityContext;

const booleanToText = (val) => (val ? 'true' : 'false');

export const GetRoomInfo = (type) => {
  // @type 'normal', 'autosave'
  // triggers get room info -> room info will come back in the callback -> window.GetRoomInfo
  sendUnityEvent('RoomModule', 'GetRoomInfo', type);
};

export const GetRetailConfiguratorRoomInfo = (type) => {
  sendUnityEvent('RoomModule', 'GetRetailConfiguratorRoomInfo', type);
}

export const GetGroupPropsInfo = () => {
  // triggers get group prop info -> group prop info will come back in the callback -> window.GetGroupPropsInfo
  sendUnityEvent('RoomModule', 'GetGroupPropsInfo');
};

export const GetGroupPropsInfoProductBuilder = () => {
  // triggers get group prop info -> group prop info will come back in the callback -> window.GetGroupPropsInfo
  sendUnityEvent('RoomModule', 'GetGroupPropsInfoProductBuilder');
};

export const ModifyCutawayLayer = (data) => {
    sendUnityEvent('RoomModule', 'ModifyCutawayLayer', JSON.stringify(data));
  }

export const sendUnityEvent = (...args) => {
  if (window.LFApp.unity.actionsDebuggingEnabled) {
    LogCurator('UNITY_SEND_ARGS', ...args);
  }

  try {
    // if (callConfiguratorMethods()) {
    //   configuratorUnityContext.send(...args);
    // } else {
    //   unityContext.send(...args);
    // }
    unityContext.send(...args);
  } catch (e) {
    LogCurator('UNITY_SEND_ARGS', ...args);
    //captureException(e);
    throw e;
  }
};

export const callConfiguratorMethods = () => {
  return isRetailAutomation();
};

export const createMaterialModule = (moduleName = 'MaterialModule', _sendUnityEvent = sendUnityEvent) => ({
  /**
   * @param {{
   *  id: number;
   *  textureUrl: string;
   *  mapType: number;
   * }} data
   * @returns void
   */
  OnSelectTextureReceiver(data) {
    _sendUnityEvent(moduleName, 'OnSelectTextureReceiver', JSON.stringify(data));
  },

  SetDefaultMaterialAndTexture(data) {
    _sendUnityEvent(moduleName, 'SetDefaultMaterialAndTexture', JSON.stringify(data));
  },

  OnSelectDefaultTextureReceiver({ textureUrl, mapType }) {
    _sendUnityEvent(
      moduleName,
      'OnSelectDefaultTextureReceiver',
      JSON.stringify({ textureUrl, mapType })
    );
  },

  /**
   * @param {{
   *  id: number;
   *  materialUrl: string;
   * }} data
   * @returns void
   */
  OnSelectMaterialReceiver(data) {
    LogCurator('OnSelectMaterialReceiver', data);
    _sendUnityEvent(moduleName, 'OnSelectMaterialReceiver', JSON.stringify(data));
  },

  /**
   * @param {{
   *  width: number;
   *  height: number;
   *  tilingOptionType: number;
   * }} data
   * @returns void
   */
  OnUpdateTilingSizeReceiver({ width, height, tilingOptionType }) {
    LogCurator('OnUpdateTilingSizeReceiver', {
      width,
      height,
      tilingOptionType,
      unityWidth: cmToUnitySize(width),
      unityHeight: cmToUnitySize(height),
    });

    const isWidthValid = typeof width === 'number' && !Number.isNaN(width);
    const isHeightValid = typeof height === 'number' && !Number.isNaN(height);

    if (!isWidthValid || !isHeightValid) {
      console.error('OnUpdateTilingSizeReceiver height or width not number ');
      return;
    }

    _sendUnityEvent(
      moduleName,
      'OnUpdateTilingSizeReceiver',
      JSON.stringify({
        tilingOptionType,
        xValue: cmToUnitySize(width),
        yValue: cmToUnitySize(height),
      })
    );
  },

  /**
   * @param {{
   *  x: number;
   *  y: number;
   *  tilingOptionType: number;
   * }} data
   * @returns void
   */
  OnUpdateTilingOffsetReceiver(data) {
    _sendUnityEvent(
      moduleName,
      'OnUpdateTilingOffsetReceiver',
      JSON.stringify({
        ...data,
        xValue: parseFloat(data.x),
        yValue: parseFloat(data.y),
      })
    );
  },

  /**
   * @param {{
   *  width: number;
   *  height: number;
   *  x: number;
   *  y: number;
   *  rotation: number;
   *  tilingOptionType: number;
   * }} data
   * @returns void
   */
  OnUpdateRotationReceiver({ width, height, x, y, rotation, tilingOptionType }) {
    LogCurator('OnUpdateRotationReceiver', {
      xSize: cmToUnitySize(width),
      ySize: cmToUnitySize(height),
      xPosition: x,
      yPosition: y,
      rotation,
      tilingOptionType,
    });
    _sendUnityEvent(
      moduleName,
      'OnUpdateRotationReceiver',
      JSON.stringify({
        xSize: cmToUnitySize(width),
        ySize: cmToUnitySize(height),
        xPosition: x,
        yPosition: y,
        rotation,
        tilingOptionType,
      })
    );
  },

  /**
   * @param value: number;
   * @returns void
   */
  OnUpdateRoughnessValueReceiver(value) {
    _sendUnityEvent(moduleName, 'OnUpdateRoughnessValueReceiver', parseFloat(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  InvertRoughnessToggleReceiver(value) {
    _sendUnityEvent(moduleName, 'InvertRoughnessToggleReceiver', booleanToText(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  UseCustomRoughnessMapToggleReceiver(value) {
    LogCurator('sasha toggle UseCustomRoughnessMapToggleReceiver', value);
    _sendUnityEvent(moduleName, 'UseCustomRoughnessMapToggleReceiver', booleanToText(value));
  },

  /**
   * @param status: boolean;
   * @param tilingOptionType: string;
   * @returns void
   */
  AddRemoveSeparateTilingOptionReceiver({ status, tilingOptionType }) {
    LogCurator('AddRemoveSeparateTilingOptionReceiver', {
      status: booleanToText(status),
      tilingOptionType,
    });
    _sendUnityEvent(
      moduleName,
      'AddRemoveSeparateTilingOptionReceiver',
      JSON.stringify({
        status: booleanToText(status),
        tilingOptionType,
      })
    );
  },

  /**
   * @param value: number;
   * @returns void
   */
  OnUpdateNormalValueReceiver(value) {
    _sendUnityEvent(moduleName, 'OnUpdateNormalValueReceiver', parseFloat(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  InvertNormalToggleReceiver(value) {
    _sendUnityEvent(moduleName, 'InvertNormalToggleReceiver', booleanToText(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  UseCustomNormalMapToggleReceiver(value) {
    _sendUnityEvent(moduleName, 'UseCustomNormalMapToggleReceiver', booleanToText(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  async UseGenerateNormalMapToggleReceiver({ id, active }) {
    const textureTiling = selectDataByTilingType(getAppState(), TILING_TYPE.TEXTURE);
    if (!textureTiling) {
      console.error('UseGenerateNormalMapToggleReceiver textureTiling missing');
      //captureException('UseGenerateNormalMapToggleReceiver textureTiling missing');
      return;
    }
    const data = {
      mapId: id,
      status: active,
      textureWidth: textureTiling.width,
      textureHeight: textureTiling.height,
      textureRotation: textureTiling.rotation || 0,
    };
    LogCurator('UseGenerateNormalMapToggleReceiver', data);
    _sendUnityEvent(moduleName, 'UseGenerateNormalMapToggleReceiver', JSON.stringify(data));
  },

  /**
   * @param value: number;
   * @returns void
   */
  OnUpdateTransparencyValueReceiver(value) {
    _sendUnityEvent(moduleName, 'OnUpdateTransparencyValueReceiver', parseFloat(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  InvertTransparencyToggleReceiver(value) {
    _sendUnityEvent(moduleName, 'InvertTransparencyToggleReceiver', booleanToText(value));
  },

  InvertAoToggleReceiver(active) {
    _sendUnityEvent(moduleName, 'InvertAoToggleReceiver', booleanToText(active));
  },

  InvertMetallicToggleReceiver(active) {
    _sendUnityEvent(moduleName, 'InvertMetallicToggleReceiver', booleanToText(active));
  },

  GenerateMapReceiver(mapType) {
    LogCurator('GenerateMapReceiver', mapType);
    _sendUnityEvent(moduleName, 'GenerateMapReceiver', mapType);
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  SetTransparencyFromDesignReceiver(value) {
    _sendUnityEvent(moduleName, 'SetTransparencyFromDesignReceiver', booleanToText(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  UseCustomTransparencyMapToggleReceiver(value) {
    _sendUnityEvent(moduleName, 'UseCustomTransparencyMapToggleReceiver', booleanToText(value));
  },

  /**
   * @param value: number;
   * @returns void
   */
  OnUpdateAoValueReceiver(value) {
    _sendUnityEvent(moduleName, 'OnUpdateAoValueReceiver', parseFloat(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  UseCustomAOMapToggleReceiver(value) {
    _sendUnityEvent(moduleName, 'UseCustomAOMapToggleReceiver', booleanToText(value));
  },

  /**
   * @param value: number;
   * @returns void
   */
  OnUpdateMetallicValueReceiver(value) {
    _sendUnityEvent(moduleName, 'OnUpdateMetallicValueReceiver', parseFloat(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  UseCustomMetallicMapToggleReceiver(value) {
    _sendUnityEvent(moduleName, 'UseCustomMetallicMapToggleReceiver', booleanToText(value));
  },

  /**
   * @param value: number;
   * @returns void
   */
  OnUpdateEmissionValueReceiver(value) {
    _sendUnityEvent(moduleName, 'OnUpdateEmissionValueReceiver', parseFloat(value));
  },

  /**
   * @param value: number;
   * @returns void
   */
  OnUpdateClearCoatValueReceiver(value) {
    _sendUnityEvent(moduleName, 'OnUpdateClearCoatValueReceiver', parseFloat(value));
  },

  /**
   * @param value: boolean;
   * @returns void
   */
  OnEffectLightColorBounceEnableDisableReceiver(value) {
    _sendUnityEvent(
      moduleName,
      'OnEffectLightColorBounceEnableDisableReceiver',
      booleanToText(value)
    );
  },
  /**
   * @param value: boolean;
   * @returns void
   */
  UseSpecularCalculationReceiver(value) {
    _sendUnityEvent(moduleName, 'UseSpecularCalculationReceiver', booleanToText(value));
  },

  /**
   * @param tilingType: number; // 0 | 1
   * @returns void
   */
  OnSetFitReceiver(tilingType) {
    LogCurator('sasha OnSetFitReceiver', tilingType);
    _sendUnityEvent(
      moduleName,
      'OnSetFitReceiver',
      typeof tilingType === 'object' ? tilingType : JSON.stringify(tilingType)
    );
  },

  /**
   * @param tilingType: number;
   * @returns void
   */
  OnLockTilingReceiver(tilingType) {
    console.log(
      'before lock send ',
      moduleName,
      'OnLockTilingReceiver',
      JSON.stringify(tilingType)
    );
    _sendUnityEvent(moduleName, 'OnLockTilingReceiver', JSON.stringify(tilingType));
  },

  /**
   * @param color: string;
   * @returns void
   */
  OnUpdateColorReceiver(color) {
    _sendUnityEvent(moduleName, 'OnUpdateColorReceiver', color);
  },

  OnCallBase64ImageDataReceiver() {
    window.tOnCallBase64ImageDataReceiver = performance.now();
    _sendUnityEvent(moduleName, 'OnCallBase64ImageDataReceiver');
  },

  GetBase64DataUsingTextureName(data) {
    LogCurator('GetBase64DataUsingTextureName', data);
    _sendUnityEvent(moduleName, 'GetBase64DataUsingTextureName', JSON.stringify(data));
  },

  OnSelectEditMaterialReceiver() {
    _sendUnityEvent(moduleName, 'OnSelectEditMaterialReceiver');
  },

  OnSelectPasteMaterial() {
    _sendUnityEvent(moduleName, 'OnSelectPasteMaterial');
  },

  SelectObjectOnTheBasisOfMaterialProperty() {
    _sendUnityEvent(moduleName, 'SelectObjectOnTheBasisOfMaterialProperty');
  },

  OnClickEditMaterial() {
    _sendUnityEvent(moduleName, 'OnClickEditMaterial');
  },

  UpdateTextureVersionReceiver({ id, version }) {
    // updates version of texture after uploading
    LogCurator('UpdateTextureVersionReceiver', { id, version });
    _sendUnityEvent(
      moduleName,
      'UpdateTextureVersionReceiver',
      JSON.stringify({
        textureId: `${id}`,
        textureVersion: version,
      })
    );
  },

  async SetMaterialPropertiesOnObjectReceiver(objectData) {
    // const changedMapsPathOld = objectData.changedMapsPath;
    const objectWithDefaultTextures = await addDefaultTexturesToObject(objectData);
    // if (objectData.methodName === '_undoMaterial') {
    //   objectWithDefaultTextures['changedMapsPath'] = changedMapsPathOld;
    // }
    LogCurator('objectWithDefaultTextures', objectWithDefaultTextures);
    _sendUnityEvent(
      moduleName,
      'SetMaterialPropertiesOnObjectReceiver',
      JSON.stringify(objectWithDefaultTextures)
    );
  },

  async SetMaterialPropertiesOnGivenObject(
    objectData,
    objectName,
    doNoParseIncomingObject = false
  ) {
    // By default, parsing the object.
    // And, if already sending the parsed objectData then send doNoParseIncomingObject as false to prevent multiple parsing
    const objectWithDefaultTextures = doNoParseIncomingObject
      ? objectData
      : await addDefaultTexturesToObject(objectData);
    LogCurator('SetMaterialPropertiesOnGivenObject', objectWithDefaultTextures);
    _sendUnityEvent(
      moduleName,
      'SetMaterialPropertiesOnGivenObject',
      JSON.stringify({
        objectName,
        objectData: objectWithDefaultTextures,
      })
    );
  },

  async setDefaultTexture({
    texture,
    mapType,
    isCan = false,
    isPack = false,
    isConfigurator = false,
    unitySelectedObjectInfo,
  }) {
    const textureDbData = await updateDbTexture(texture);
    const textureUrl = textureDbData?.file || texture.texture_file || texture.low_texture_file; // doesn't make sense to use texture file url if its outdated (it's valid only 1 hour)
    if (!textureUrl) return false;
    try {
      const forCans = {
        id: isProductionUrl ? 11247 : 3828,
        isGlassMaterial: false,
        isConfigurator: false,
      };

      const forOtherObject = {
        id: isProductionUrl ? 11248 : 3861,
        isGlassMaterial: false,
        isConfigurator: false,
      };

      const id = isCan ? forCans?.id : forOtherObject?.id;

      const tilingWidth = (isCan || isPack) ? "120" : unitySizeToCM(unitySelectedObjectInfo?.tilingOffsetValue?._MainTex?.xMatTiling) /
                CM_IN_ONE_INCHES || 0
      const tilingHeight = (isCan || isPack) ? "120" : unitySizeToCM(unitySelectedObjectInfo?.tilingOffsetValue?._MainTex?.yMatTiling) /
                CM_IN_ONE_INCHES || 0

      const materialInfo = await apiGet(`${OP_GET_MATERIAL_API}?id=${id}`);

      if (materialInfo?.results) {
        const blobUrl = materialInfo?.results[0]?.material_image
          ? await urlToBlobUrl(materialInfo?.results[0]?.material_image)
          : '';

        const payload = {
          textureDataModel: {
            id: texture.id,
            textureUrl: textureUrl,
            mapType,
            version: texture.version,
            skuId: texture.sku_id,
            content: texture.description,
            textureWidth:
              tilingWidth, // Unity need texture width in inches
            textureHeight:
              tilingHeight, // Unity need texture height in inches
            textureFormat: getTextureFormat(textureDbData),
            textureName: textureDbData?.name || texture?.name,
            isGeneratedMap: false,
            textureRotation: parseInt(texture.rotation) || 0,
            isConfigurator: isConfigurator || false,
          },
          materialDataModel: isCan
            ? { ...forCans, materialUrl: blobUrl }
            : { ...forOtherObject, materialUrl: blobUrl },
        };
        this.SetDefaultMaterialAndTexture(payload);
      }
    } catch (error) {
      //captureException(error);
      console.error(error);
      return false;
    }
    return true;
  },

  async selectTexture({ texture, mapType, isConfigurator = false, isArtwork = false, unitySelectedObjectInfo }) {
    const textureDbData = await updateDbTexture(texture);
    const textureUrl = textureDbData?.file || texture.texture_file || texture.low_texture_file; // doesn't make sense to use texture file url if its outdated (it's valid only 1 hour)
    if (!textureUrl) return false;
    const tilingWidth = unitySizeToCM(unitySelectedObjectInfo?.tilingOffsetValue?._MainTex?.xMatTiling) /
                CM_IN_ONE_INCHES || 0
    const tilingHeight = unitySizeToCM(unitySelectedObjectInfo?.tilingOffsetValue?._MainTex?.yMatTiling) /
                CM_IN_ONE_INCHES || 0
    try {
      const { textureHeight, textureWidth } = await getTextureSize(texture, textureUrl);
      this.OnSelectTextureReceiver({
        id: texture.id,
        textureUrl: textureUrl,
        mapType,
        version: texture.version,
        skuId: texture.sku_id,
        content: texture.description,
        textureWidth: isArtwork? tilingWidth : textureWidth / CM_IN_ONE_INCHES, // Unity need texture width in inches
        textureHeight: isArtwork? tilingHeight : textureHeight / CM_IN_ONE_INCHES, // Unity need texture height in inches
        textureFormat: getTextureFormat(textureDbData),
        textureName: textureDbData?.name || texture?.name,
        isGeneratedMap: false,
        textureRotation: parseInt(texture.rotation) || 0,
        isConfigurator: isConfigurator || false,
      });
    } catch (error) {
      //captureException(error);
      console.error(error);
      return false;
    }
    return true;
  },

  async selectLowTexture({ texture, mapType, isGeneratedMap, isConfiguratorView }) {
    // discuss if we need to store it in different idb instance
    const textureDbData = await updateDbLowTexture(texture, { IS_GENERATED_MAP: true });
    const textureUrl = textureDbData?.file || texture.low_texture_file;

    // const { textureHeight, textureWidth } = await getTextureSize(texture, textureUrl);
    const textureTilingData = selectDataByTilingType(getAppState(), TILING_TYPE.TEXTURE);

    if (!textureTilingData) {
      // captureException('selectLowTexture textureTilingData is missing LF_KDL234');
      return;
    }

    if (isConfiguratorView) {
      applyTexture({
        texture: {
          ...texture,
          isGeneratedMap: true,
        },
        mapType,
        isUpdate: false,
      });
      return;
    }

    this.OnSelectTextureReceiver({
      id: texture.id,
      textureUrl,
      mapType,
      version: texture.version,
      skuId: texture.sku_id,
      content: texture.description,
      isGeneratedMap,
      textureName: textureDbData?.name || texture?.name,
      textureFormat: getTextureFormat(textureDbData),
      textureWidth: textureTilingData.width / CM_IN_ONE_INCHES, // Unity need texture width in inches
      textureHeight: textureTilingData.height / CM_IN_ONE_INCHES, // Unity need texture height in inches
      textureRotation: parseInt(textureTilingData.rotation) || 0,
    });
  },

  async selectDefaultTexture({ texture, isReset = false, currentSelected }) {
    try {
      // Validate texture and json_file
      if (!texture?.json_file) {
        dispatcher(setCuratorLoader(false));
        errorToast('Texture JSON file missing.');
        return;
      }

      // Load JSON and extract materialId
      const jsonValue = await getJson(texture?.json_file);
      if (!jsonValue) throw new Error('Failed to load texture JSON.');

      const materialId = jsonValue.loadedMaterialId;
      let materialInfo = null;

      // Try to fetch material info if materialId exists
      if (materialId) {
        const data = await getMaterial(materialId);
        if (data) {
          materialInfo = data;
        } else {
          const res = await apiGetMaterials(`id=${materialId}`);
          materialInfo = res?.results?.[0] || null;
        }
      }

      // Build base payload
      const payload = {
        isSavedMaterial: true,
        materialData: {
          ...jsonValue,
          loadedMaterialPath: materialInfo?.material_image || null,
        },
      };

      // Use low_texture_file first for performance
      const textureFile = texture.low_texture_file || texture.texture_file;
      if (!textureFile) throw new Error('Texture file missing.');

      const blob = await fetch(textureFile).then((r) => r.blob());
      const diffusePath = URL.createObjectURL(blob);

      if (isReset) {
        // Dispatch final payload
        this.OnSelectMaterialReceiver({
          isSavedMaterial: true,
          materialData: { ...currentSelected, diffusePath },
        });
      } else {
        // Dispatch final payload
        this.OnSelectMaterialReceiver({
          ...payload,
          materialData: {
            ...payload.materialData,
            diffusePath,
          },
        });
      }
    } catch (err) {
      console.error('selectDefaultTexture error:', err);
      errorToast('Something went wrong while applying texture.');
    } finally {
      dispatcher(setCuratorLoader(false));
    }
  },

  async selectMaterial({ material, isConfigurator = false }) {
    console.log('material RRR', material);
    const cloneMaterial = { ...material };
    if (material?.material_json) {
      const jsonValue = await getJson(material?.material_json);
      let jsonData = jsonValue?.[0];
      if (jsonData) {
        const textureKeys = [
          { key: 'normalId', pathKey: 'normalPath' },
          { key: 'AOId', pathKey: 'AOPath' },
          { key: 'diffuseId', pathKey: 'diffusePath' },
          { key: 'displacementId', pathKey: 'displacementPath' },
          { key: 'metallicId', pathKey: 'metallicPath' },
          { key: 'roughnessId', pathKey: 'roughnessPath' },
          { key: 'transparencyId', pathKey: 'transparencyPath' },
        ];
        textureKeys.forEach(({ key, pathKey }) => {
          if (!jsonData[key]) {
            delete jsonData[pathKey];
          }
        });
        const materialId = jsonData?.loadedMaterialId;
        let materialInfo = null;
        let material = {}; // Make sure this is declared

        // Loop through each texture ID separately
        for (const { key, pathKey } of textureKeys) {
          const textureId = jsonData?.[key];
          if (textureId) {
            let textureInfo = await getTexture(textureId);
            if (!textureInfo) {
              const textureList = await apiGetTextureList({ query: `id=${textureId}` });
              if (textureList?.results?.length) {
                textureInfo = textureList.results[0];
              }
            }

            if (textureInfo) {
              const textureDbData = await updateDbTexture({ ...textureInfo });
              jsonData[pathKey] = textureDbData?.file;
            }
          }
        }

        // Process material
        if (materialId) {
          let data = await getMaterial(materialId);
          if (!data) {
            materialInfo = await apiGetMaterials(`id=${materialId}`);
            if (materialInfo?.results?.length) {
              materialInfo = materialInfo.results[0];
            }
          } else {
            material = {
              ...cloneMaterial,
              material_image: data?.material_image || data?.file,
              loadedMaterialPath: data?.file,
            };
            materialInfo = {};
            if (data?.file) {
              jsonData.loadedMaterialPath = data?.file;
            }
          }
        }

        // Save and apply material
        if (materialInfo && Object?.keys?.(materialInfo)?.length > 0 && materialInfo) {
          let materialDbData = await updateDbMaterial({
            ...material,
            ...materialInfo,
            material_image: materialInfo?.material_image || material?.material_image,
          });

          if (materialDbData?.loadedMaterialPath || materialDbData?.file) {
            jsonData.loadedMaterialPath =
              materialDbData?.file || materialDbData?.loadedMaterialPath;
          }
        }

        // Final object preparation for Unity
        const finalObjectData = await getTexturePathsForUnityNoChangedMap(jsonData);

        if (finalObjectData) {
          let materialRecieveObj = {
            isSavedMaterial: true,
            materialData: finalObjectData,
          };
          this.OnSelectMaterialReceiver(materialRecieveObj);
        } else {
          dispatcher(setCuratorLoader(true));
          errorToast('Something went wrong on applying material.');
        }
      } else {
        dispatcher(setCuratorLoader(true));
        errorToast('Something went wrong on applying material.');
      }
      return;
    }
    const materialDbData = await updateDbMaterial(material);
    if (material?.tile_textures_data?.length) {
      await Promise.all(
        material?.tile_textures_data?.map(async (item) => await updateDbTexture(item))
      );
    }
    // Here we check if the selected props have the glass material filter option based on the material ID or name
    const isGlassMaterial = material?.filteroptions?.some(
      ({ name, id }) =>
        +id === GLASS_MATERIAL_ID || name?.trim()?.toLowerCase() === GLASS_MATERIAL_OPTION_NAME
    );
    const gamificationTooltipData = selectGamificationTooltipData(getAppState());
    const isOnboardingState = isUserOnboarding();
    const { step } = gamificationTooltipData;
    let materialRecieveObj = {
      id: material.id,
      materialUrl: materialDbData?.file || material.material_image,
    };
    if (isOnboardingState) {
      const isOtherObject =
        step === 'ADD_WALL_FINISH' || step === 'QUICK_MESSAGE' || step === 'CLICK_ARROW';
      if (isOtherObject) {
        dispatcher(setSelectedOnboardingOtherMaterial(material));
      } else {
        dispatcher(setSelectedOnboardingMaterial(material));
      }
      const onboardingSelectedProduct = selectSelectedOnboardingProduct(getAppState());
      const allOnboardingData = selectAllOnboardingData(getAppState());
      const selectedObjectList = selectSelectedObjectList(getAppState());
      const { other_object_data } = allOnboardingData;
      const { styling_object_name } = onboardingSelectedProduct;
      materialRecieveObj.isOtherObject = isOtherObject;
      materialRecieveObj.objectName = selectedObjectList.length
        ? selectedObjectList[0]?.objectName
        : '';
      materialRecieveObj.styleObjectActualName = isOtherObject
        ? other_object_data?.name
        : styling_object_name;
    } else {
      if (material?.textures?.length) {
        let payloadToOperate = { ...materialRecieveObj, ...material };

        materialRecieveObj = {
          id: payloadToOperate.id,
          tile_textures_data: payloadToOperate.tile_textures_data,
          tiling_and_offset: payloadToOperate.tiling_and_offset,
          depth_value: payloadToOperate.depth_value,
          mattalic_value: payloadToOperate.mattalic_value,
          roughness_value: payloadToOperate.roughness_value,
        };
      }
    }
    materialRecieveObj.isGlassMaterial = isGlassMaterial;
    materialRecieveObj['isConfigurator'] = isConfigurator || false;
    this.OnSelectMaterialReceiver(materialRecieveObj);
  },
  SendMaterialPropertiesByObjectNameReceiver(objectName) {
    sendUnityEvent('MaterialModule', 'SendMaterialPropertiesByObjectNameReceiver', objectName);
  },
  BreakMaterialOfSelectedObjects() {
    sendUnityEvent('MaterialModule', 'BreakMaterialOfSelectedObjects');
  },
  SetMaterialPropertiesOnGivenMaterialNames(data) {
    LogCurator('SetMaterialPropertiesOnGivenMaterialNames', data);
    sendUnityEvent(
      'MaterialModule',
      'SetMaterialPropertiesOnGivenMaterialNames',
      JSON.stringify(data)
    );
  },
});

export const createShortcutsModule = (
  moduleName = 'ShortcutsModule',
  _sendUnityEvent = sendUnityEvent
) => ({
  Switch3d2DViewReceiver() {
    _sendUnityEvent(moduleName, 'Switch3d2DViewReceiver');
  },
  OnSetup2DViewsReceiver(viewMode) {
    _sendUnityEvent(moduleName, 'OnSetup2DViewsReceiver', viewMode);
  },
  TransformTypeMoveReceiver() {
    _sendUnityEvent(moduleName, 'TransformTypeMoveReceiver');
  },
  TransformTypeRotateReceiver() {
    _sendUnityEvent(moduleName, 'TransformTypeRotateReceiver');
  },
  TransformTypeScaleReceiver() {
    _sendUnityEvent(moduleName, 'TransformTypeScaleReceiver');
  },
  StyleOnlyReceiver(active) {
    _sendUnityEvent(moduleName, 'StyleOnlyReceiver', booleanToText(active));
  },
  TransformSpaceReceiver(mode) {
    _sendUnityEvent(moduleName, 'TransformSpaceReceiver', parseInt(mode));
  },
  OnClickSelectAxisButtonReceiver(axis) {
    _sendUnityEvent(moduleName, 'OnClickSelectAxisButtonReceiver', axis);
  },
  DuplicatePropReceiver() {
    pubSubState.isDuplicate = true;
    _sendUnityEvent(moduleName, 'DuplicatePropReceiver');
  },
  DeleteObjectReceiver() {
    _sendUnityEvent(moduleName, 'DeleteObjectReceiver');
  },
  copyMaterial() {
    _sendUnityEvent(moduleName, 'CopyMaterialReceiver');
  },
  pasteMaterial(defaultTextureList) {
    undoRedo.objectProperties.addPasteMaterialParams(defaultTextureList);
    const params = defaultTextureList
      ? JSON.stringify({ defaultTextureDatas: defaultTextureList})
      : '';
    LogCurator('PasteMaterialReceiver', params);
    _sendUnityEvent(moduleName, 'PasteMaterialReceiver', params);
  },
  focusObject() {
    _sendUnityEvent(moduleName, 'FocusObjectReceiver');
  },
  toggleHighlightSelected(active) {
    _sendUnityEvent(moduleName, 'HeightlightOnOffReceiver', booleanToText(active));
  },
  toggleDimensions(measureUnit) {
    _sendUnityEvent('MeasureModule', 'OnSelectMeasurementToolReceiver', measureUnit);
  },
  toggleLightsVisibility(active) {
    _sendUnityEvent(moduleName, 'LightsEnableDisableReceiver', booleanToText(active));
  },
  focusEverything() {
    _sendUnityEvent(moduleName, 'FocusEverythingReceiver');
  },
  deselectAll() {
    _sendUnityEvent(moduleName, 'DeselectAllReceiver');
  },
  snapObject(snap) {
    _sendUnityEvent(moduleName, 'SnapObjectReceiver', booleanToText(snap));
  },
  removeSelection(clicked) {
    _sendUnityEvent(moduleName, 'RemoveSelectionReceiver', booleanToText(clicked));
  },
  addSelection(clicked) {
    _sendUnityEvent(moduleName, 'AddSelectionReceiver', booleanToText(clicked));
  },
  SingleObjectSelectionReceiver(clicked) {
    _sendUnityEvent(moduleName, 'SingleObjectSelectionReceiver', booleanToText(clicked));
  },
  SnapRotationKey(active) {
    _sendUnityEvent(moduleName, 'SnapRotationKey', booleanToText(active));
  },
  SetSnapRotationValue(rotationValue) {
    _sendUnityEvent(moduleName, 'SetSnapRotationValue', parseFloat(rotationValue));
  },
  SetPositionAlongAxis({ value, transformType }) {
    _sendUnityEvent(
      moduleName,
      'SetPositionAlongAxis',
      JSON.stringify({
        value,
        type: transformType,
      })
    );
  },
  StylePanelEnableReceiver(active) {
    _sendUnityEvent(moduleName, 'StylePanelEnableReceiver', booleanToText(active));
  },
  GroupSelectedObject() {
    _sendUnityEvent(moduleName, 'GroupSelectedObject');
  },
  UnGroupSelectedObject() {
    _sendUnityEvent(moduleName, 'UnGroupSelectedObject');
  },
  SelectPreviousSibilingChild() {
    _sendUnityEvent(moduleName, 'SelectPreviousSibilingChild');
  },
  SelectNextSibilingChild() {
    _sendUnityEvent(moduleName, 'SelectNextSibilingChild');
  },
  SetGizmoPivotReceiver() {
    _sendUnityEvent(moduleName, 'SetGizmoPivotReceiver');
  },
  ResetSelectedPropTransformReceiver() {
    _sendUnityEvent(moduleName, 'ResetSelectedPropTransformReceiver');
  },
  ResetSelectedPropPositionReceiver() {
    _sendUnityEvent(moduleName, 'ResetSelectedPropPositionReceiver');
  },
  SetRenderInProgressReceiver(active) {
    console.log(moduleName, active, 'SetRenderInPregressReceiver', 'check unity event');
    _sendUnityEvent(moduleName, 'SetRenderInPregressReceiver', booleanToText(active));
  },
  ToggleDebuggerModeReciever(active) {
    _sendUnityEvent(moduleName, 'ToggleDebuggerModeReciever', booleanToText(active));
  },
});

export const createAlignmentModule = (
  moduleName = 'AlignmentModule',
  _sendUnityEvent = sendUnityEvent
) => ({
  cancelAlignment() {
    _sendUnityEvent(moduleName, 'CancelAlignmentReceiver');
  },
  alignObjects(data) {
    _sendUnityEvent(moduleName, 'AlignObjectReceiver', JSON.stringify(data));
  },
  applyAlignment() {
    _sendUnityEvent(moduleName, 'ApplyAlignmentReceiver');
  },
  checkCancelAlignment() {
    _sendUnityEvent(moduleName, 'CheckCancelAlignmentStatus');
  },
  alignObjectUnity() {
    _sendUnityEvent(moduleName, 'StoreAlignmentReceiver');
  },
  assignReferenceObject() {
    _sendUnityEvent(moduleName, 'AssignReferenceObjectReceiver');
  },
  hoverEnter(data) {
    _sendUnityEvent(moduleName, 'OnHoverEnterAlignmentButtonReceiver', JSON.stringify(data));
  },
  hoverExit() {
    _sendUnityEvent(moduleName, 'OnHoverExitAlignmentButtonReceiver');
  },
});

export const createSentryUnityModule = (
  moduleName = 'SentryModule',
  _sendUnityEvent = sendUnityEvent
) => ({
  // this sentry module is used for & by Unity only
  initUser(userInfo = {}) {
    _sendUnityEvent(moduleName, 'InitUser', JSON.stringify(userInfo));
  },
});

function UnityContainer({ children }) {
  const dispatch = useDispatch();

  // const sendUnityEvent = unityContext.send;
  // uncomment for debugging;

  const handleLoad = (data) => {
    const { roomData } = curatorSelector(getAppState());
    if (roomData?.is_custom || data?.isProjectRoom) {
      handleLoadProject(data);
    } else {
      sendUnityEvent('RoomModule', 'CreateRoomReceiver', JSON.stringify(data));
    }
  };

  const handleLoadProject = (data) => {
    LogCurator('CreateProjectReceiver', data);
    sendUnityEvent('RoomModule', 'CreateProjectReceiver', JSON.stringify(data));
  };

  const handleLoadProjectBuilder = (data) => {
    if (data?.newEntry) {
      LogCurator('OpenProductBuilderReceiver', data);
      sendUnityEvent('RoomModule', 'OpenProductBuilderReceiver', JSON.stringify(data));
    } else {
      LogCurator('LoadProductBuilderReceiver', data);
      sendUnityEvent('RoomModule', 'LoadProductBuilderReceiver', JSON.stringify(data));
    }
  };

  const handleMovement = (data) => {
    sendUnityEvent('MainCameraPrefab(Clone)', 'SetTransformType', JSON.stringify(data));
  };

  const convertCameraToUnityModel = (camera) => {
    if (!camera) {
      //captureException(new Error('Camera is missing. LF_3242388888823'));
      return;
    }

    const result = calculateSafeFrameSize({
      cameraHeight: parseInt(camera.resoY),
      cameraWidth: parseInt(camera.resoX),
    });

    return {
      cameraId: camera.id,
      distanceToSet: camera.distanceToSet,
      fov: decimals(camera.fov, 3),
      xTransRot: camera.xTransRot,
      yTransRot: camera.yTransRot,
      zTransRot: camera.zTransRot,
      centerObjectxPos: camera.centerObjectxPos,
      centerObjectyPos: camera.centerObjectyPos,
      centerObjectzPos: camera.centerObjectzPos,
      isCameraCorrection: camera.isCameraCorrection,
      lensShiftY: camera.lensShiftY,
      cameraHeight: camera.cameraHeight,
      cameraRotX: camera.cameraRotX,
      cameraRotZ: camera.cameraRotZ,
      focalLength: camera.focalLength,
      isdepthOfField: camera.isdepthOfField,
      selectedObjectName: camera.selectedObjectName,
      blurIntensity: camera.blurIntensity,
      xPos: camera.xPos,
      yPos: camera.yPos,
      zPos: camera.zPos,
      // resoX: camera.resoX,
      // resoY: camera.resoY,
      cameraName: camera.cameraName,
      isPredefinedCamera: camera.isPredefinedCamera,

      canvas_width: parseFloat(camera.canvas_width) || 0,
      canvas_height: parseFloat(camera.canvas_height) || 0,
      safeFrameWidth: result?.width || 0,
      safeFrameHeight: result?.height || 0,

      sensor_width: camera.sensor_width || 0,
      sensor_height: camera.sensor_height || 0,
      fov_axis: camera.fov_axis,
      gate_fit: camera.gate_fit,

      focusXPos: camera.focusXPos,
      focusYPos: camera.focusYPos,
      focusZPos: camera.focusZPos,
      horizontalFov: camera.horizontalFov,
    };
  };

  // create camera functions
  const handleSelectedCamera = (camera, { updateGlobalData = true } = {}) => {
    // @updateGlobalData -> do we want to update global width/height and other data which depends on camera data or not
    if (!camera) return;

    const unityCamera = convertCameraToUnityModel(camera);
    LogCurator('handleSelectedCamera', { camera, unityCamera });
    sendUnityEvent('CameraModule', 'SelectedCameraReceiver', JSON.stringify(unityCamera));

    if (updateGlobalData) {
      dispatch(setGlobalHeight(camera.resoY));
      dispatch(setGlobalWidth(camera.resoX));
      dispatch(setGlobalSafeCameraFlag(true));
      dispatch(setGlobalFov(camera.fov));
    }
  };
  const handleCreateCamera = () => {
    const safeFrameSize = selectSafeFrameSize(getAppState());
    const canvasSize = selectCanvasSize(getAppState());

    sendUnityEvent(
      'CameraModule',
      'CreateCameraAngleReceiver',
      JSON.stringify({
        canvasWidth: canvasSize.width,
        canvasHeight: canvasSize.height,
        safeFrameWidth: safeFrameSize.width,
        safeFrameHeight: safeFrameSize.height,
      })
    );
  };
  const handleCameraFov = (a) => {
    sendUnityEvent('CameraModule', 'OnUpdateCameraFovReceiver', a);
  };
  const handleCameraCorrection = (a) => {
    sendUnityEvent('CameraModule', 'OnCameraVerticalTiltReceiver', a);
    LogCurator('OnCameraVerticalTiltReceiver: ', a);
  };
  const handleCameraHeight = (a) => {
    // const
    // const meter = a / CONVERT_IN_METER
    sendUnityEvent('CameraModule', 'UpdateCameraHeightReceiver', a);
  };
  const handleDepthOfField = (active) => {
    sendUnityEvent('CameraModule', 'OnSelectDepthOfFieldReceiver', active);
    dispatcher(setObjectSelectionActive(active));
  };
  const handleBlurIntensity = (a) => {
    sendUnityEvent('CameraModule', 'OnUpdateDepthOfFieldValueReceiver', a);
  };
  const handleCameraScreenshot = (cameraList) => {
    LogCurator('TakeScreenShotForRender', cameraList);
    sendUnityEvent('CameraModule', 'TakeScreenShotForRender', JSON.stringify(cameraList));
  };
  const handleCameraPopupClose = () => {
    sendUnityEvent('CameraModule', 'CloseCameraPopupReceiver');
  };

  // material module

  const materialModule = createMaterialModule('MaterialModule');
  const shortcutsModule = createShortcutsModule();
  const alignmentModule = createAlignmentModule();
  const sentryUnityModule = createSentryUnityModule();

  window.materialModule = materialModule;

  const metadataModule = {
    GetRoomMetadataList() {
      sendUnityEvent('MetadataModule', 'GetRoomMetadataList');
    },
    GetRoomMetadataListReceiver() {
      sendUnityEvent('MetadataModule', 'GetRoomMetadataListReceiver');
    },
    AddMetadataReceiver({ sequenceNo, metadataName, objectName }, loadedProp = false) {
      console.log('AddMetadataReceiver', metadataName, objectName);

      sendUnityEvent(
        'MetadataModule',
        'AddMetadataReceiver',
        JSON.stringify({ metadataName, objectName }),
        loadedProp
      ); // TODO: work on this false
    },
    OnAddMetadataButtonClickReceiver() {
      // call it to know if meta data can be applied to the object
      sendUnityEvent('MetadataModule', 'OnAddMetadataButtonClickReceiver');
      dispatcher(setObjectSelectionActive(true));
    },
    DeleteMetadataReceiver(title) {
      sendUnityEvent('MetadataModule', 'DeleteMetadataReceiver', title);
    },
    SelectMetadataReceiver(title) {
      LogCurator('sasha SelectMetadataReceiver', title);
      sendUnityEvent('MetadataModule', 'SelectMetadataReceiver', title);
    },
    EditMetadataReceiver(oldMetadataTitle, newMetadataTitle) {
      sendUnityEvent(
        'MetadataModule',
        'EditMetadataReceiver',
        JSON.stringify({
          oldMetadataName: oldMetadataTitle,
          newMetadataName: newMetadataTitle,
        })
      );
    },
    UpdateSequenceReceiver(title, newIndex, oldIndex) {
      LogCurator('sasha metadata sequence no update', {
        metadataTitle: title,
        newIndex,
        oldIndex,
      });
      sendUnityEvent(
        'MetadataModule',
        'UpdateSequenceReceiver',
        JSON.stringify({
          metadataTitle: title,
          newIndex,
          oldIndex,
        })
      );
    },
    UpdateMetadataStatusReceiver(title, enabled) {
      sendUnityEvent(
        'MetadataModule',
        'UpdateMetadataStatusReceiver',
        JSON.stringify({
          metadataTitle: title,
          status: enabled,
        })
      );
    },
    CloseFocusObjectReceiver() {
      sendUnityEvent('MetadataModule', 'CloseFocusObjectReceiver');
      dispatcher(setObjectSelectionActive(false));
    },
    AddMetadataObjectReceiver(metadataObj) {
      LogCurator('AddMetadataObjectReceiver', metadataObj);
      sendUnityEvent('MetadataModule', 'AddMetadataObjectReceiver', JSON.stringify(metadataObj));
    },
    UpdateRoomMetadataReceiver(metadataList) {
      LogCurator('UpdateRoomMetadataReceiver', metadataList);
      sendUnityEvent('MetadataModule', 'UpdateRoomMetadataReceiver', JSON.stringify(metadataList));
    },
  };

  const automationModule = {
    // GetRoomAutomationList() {
    //   sendUnityEvent('AutomationModule', 'GetRoomAutomationList');
    // },
    GetAutomationListReceiver() {
      sendUnityEvent('AutomationModule', 'GetAutomationListReceiver');
    },
    AddAutomationReceiver({ sequenceNo, automationName, objectName }, loadedProp = false) {
      console.log('AddAutomationReceiver', automationName, objectName);

      sendUnityEvent(
        'AutomationModule',
        'AddAutomationReceiver',
        JSON.stringify({ automationName, objectName }),
        loadedProp
      ); // TODO: work on this false
    },
    OnAddAutomationButtonClickReceiver() {
      sendUnityEvent('AutomationModule', 'OnAddAutomationButtonClickReceiver');
      dispatcher(setObjectSelectionActive(true));
    },
    DeleteAutomationReceiver(title) {
      sendUnityEvent('AutomationModule', 'DeleteAutomationReceiver', title);
    },
    SelectAutomationObjectReceiver(title) {
      LogCurator('sasha SelectAutomationObjectReceiver', title);
      sendUnityEvent('AutomationModule', 'SelectAutomationObjectReceiver', title);
    },
    EditAutomationReceiver(oldAutomationTitle, newAutomationTitle) {
      sendUnityEvent(
        'AutomationModule',
        'EditAutomationReceiver',
        JSON.stringify({
          oldAutomationName: oldAutomationTitle,
          newAutomationName: newAutomationTitle,
        })
      );
    },
    UpdateSequenceReceiver(title, newIndex, oldIndex) {
      LogCurator('sasha automation sequence no update', {
        automationTitle: title,
        newIndex,
        oldIndex,
      });
      sendUnityEvent(
        'AutomationModule',
        'UpdateSequenceReceiver',
        JSON.stringify({
          automationTitle: title,
          newIndex,
          oldIndex,
        })
      );
    },
    UpdateAutomationStatusReceiver(title, enabled) {
      sendUnityEvent(
        'AutomationModule',
        'UpdateAutomationStatusReceiver',
        JSON.stringify({
          automationTitle: title,
          status: enabled,
        })
      );
    },
    CloseFocusObjectReceiver() {
      sendUnityEvent('AutomationModule', 'CloseFocusObjectReceiver');
      dispatcher(setObjectSelectionActive(false));
    },
    AddAutomationObjectReceiver(automationObj) {
      LogCurator('AddAutomationObjectReceiver', automationObj);
      sendUnityEvent(
        'AutomationModule',
        'AddAutomationObjectReceiver',
        JSON.stringify(automationObj)
      );
    },
    UpdateRoomAutomationReceiver(automationList) {
      LogCurator('UpdateRoomAutomationReceiver', automationList);
      sendUnityEvent(
        'AutomationModule',
        'UpdateRoomAutomationReceiver',
        JSON.stringify(automationList)
      );
    },
  };

  const lightModule = {
    GenerateLightReceiver(lightName) {
      sendUnityEvent('LightModule', 'GenerateLightReceiver', lightName);
    },
    GenerateLightByNameReceiver({ name, id }) {
      sendUnityEvent(
        'LightModule',
        'GenerateLightByNameReceiver',
        JSON.stringify({
          id,
          lightName: name,
        })
      );
    },
    EnableLightById(id) {
      sendUnityEvent('LightModule', 'EnableLightById', JSON.stringify({ id }));
    },
    SelectLightObjectReceiver(lightId, syncLightData) {
      sendUnityEvent(
        'LightModule',
        'SelectLightObjectReceiver',
        JSON.stringify({
          id: lightId,
          syncLightData,
        })
      );
    },
    SelectLightUsingCheckBoxReceiver(lightId, syncLightData, addObject) {
      sendUnityEvent(
        'LightModule',
        'SelectLightUsingCheckBoxReceiver',
        JSON.stringify({
          id: lightId,
          syncLightData,
          addObject,
        })
      );
    },
    UpdateLightTypeReceiver(light) {
      sendUnityEvent('LightModule', 'UpdateLightTypeReceiver', JSON.stringify(light));
    },
    UpdateColorReceiver(color) {
      sendUnityEvent('LightModule', 'UpdateColorReceiver', color);
    },
    UpdateIntensityReceiver(intensity) {
      sendUnityEvent('LightModule', 'UpdateIntensityReceiver', intensity);
    },
    UpdateSizeReceiver(size) {
      sendUnityEvent('LightModule', 'UpdateSizeReceiver', size);
    },
    UpdateVisibleInReflectionReceiver(active) {
      sendUnityEvent('LightModule', 'UpdateVisibleInReflectionReceiver', booleanToText(active));
    },
    UpdateVisibleInGlassReceiver(active) {
      sendUnityEvent('LightModule', 'UpdateVisibleInGlass', booleanToText(active));
    },
    UpdateVisibleInGlossyMaterialsReceiver(active) {
      sendUnityEvent('LightModule', 'UpdateVisibleInGlossyMaterials', booleanToText(active));
    },
    UpdateSpotAngleReceiver(spotAngle) {
      sendUnityEvent('LightModule', 'UpdateSpotAngleReceiver', spotAngle);
    },
    UpdateBlendSpotReceiver(blendSpot) {
      sendUnityEvent('LightModule', 'UpdateBlendSpotReceiver', blendSpot);
    },
    OnDeleteLightFromUI(lightId) {
      sendUnityEvent('LightModule', 'OnDeleteLightFromUI', lightId);
    },
    UpdateEnvironmentColorReceiver(color) {
      // toggle color
      sendUnityEvent('LightModule', 'UpdateEnvironmentColorReceiver', color);
    },
    UpdateColorIntensityReceiver(intensity) {
      sendUnityEvent('LightModule', 'UpdateColorIntensityReceiver', parseFloat(intensity));
    },
    UpdateEnvironmentSkyboxReceiver({ url, rotation, intensity, visibleHdri = true }) {
      LogCurator('UpdateEnvironmentSkyboxReceiver', { url, rotation, intensity, visibleHdri });
      // toggle hdri
      sendUnityEvent(
        'LightModule',
        'UpdateEnvironmentSkyboxReceiver',
        JSON.stringify({ url, rotation, intensity, visibleHdri })
      );
    },
    UpdateSkyboxRotationReceiver(rotation) {
      sendUnityEvent('LightModule', 'UpdateSkyboxRotationReceiver', rotation);
    },
    UpdateEnableInRenderingReceiver(id, active) {
      sendUnityEvent(
        'LightModule',
        'UpdateEnableInRenderingReceiver',
        JSON.stringify({
          lightId: `${id}`,
          status: active,
        })
      );
    },
    UpdateAreaWidthReceiver(width) {
      sendUnityEvent('LightModule', 'UpdateAreaWidthReceiver', parseFloat(width));
    },
    UpdateAreaHeightReceiver(width) {
      sendUnityEvent('LightModule', 'UpdateAreaHeightReceiver', parseFloat(width));
    },
    UpdateSkyboxIntensityReceiver(intensity) {
      // update hdri intenstiy
      sendUnityEvent('LightModule', 'UpdateSkyboxIntensityReceiver', parseFloat(intensity));
    },
    EnableDisableHDRSkyboxReceiver(enabled) {
      sendUnityEvent('LightModule', 'EnableDisableHDRSkyboxReceiver', booleanToText(enabled));
    },
    UpdateLightNameReceiver(lightName) {
      sendUnityEvent('LightModule', 'UpdateLightNameReceiver', lightName);
    },
    GetLightDatReceiver() {
      sendUnityEvent('LightModule', 'GetLightDatReceiver');
    },
    LightsEffectReceiver(active) {
      sendUnityEvent('LightModule', 'LightsEffectReceiver', booleanToText(active));
    },
  };

  const handleGraphicQualityChange = (id) => {
    let quality = QUALITY_ID_TO_QUALITY[id];

    if (typeof quality === 'undefined') {
      quality = QUAILTY.PERFORMANCE;
      //captureException(`Quality id is not correct ID: ${id}`);
    }

    LogCurator('SetRoomQualityReceiver', quality);
    sendUnityEvent('SettingsModule', 'SetRoomQualityReceiver', quality);

    // update dpr
    const dpr = QUAILTY_TO_DPR[quality];
    if (unityContext?.unityInstance?.Module?.devicePixelRatio) {
      unityContext.unityInstance.Module.devicePixelRatio = dpr;
    }
    dispatcher(setGlobalDPR(dpr));
  };

  const handleVerticalRotationSpeed = (speed) => {
    LogCurator('OnUpdateVerticalRotationSpeedReceiver', parseFloat(speed));
    sendUnityEvent(
      'SettingsModule',
      'OnUpdateVerticalRotationSpeedReceiver',
      parseFloat(speed) || 0
    );
  };

  const handleHorizontalRotationSpeed = (speed) => {
    sendUnityEvent(
      'SettingsModule',
      'OnUpdateHorizontalRotationSpeedReceiver',
      parseFloat(speed) || 0
    );
  };

  const handleMeasureUnitChange = (index) => {
    LogCurator('handle measure unity sasha ', index);
    sendUnityEvent('MeasureModule', 'OnChangeSizeUnitReceviever', index);
  };

  const unityTigg = () => {
    sendUnityEvent('RoomModule', 'GetRoomInfo', 'normal');
  };

  const roomModule = {
    GetRoomInfo,
    GetRetailConfiguratorRoomInfo,
    GetGroupPropsInfo,
    resetAll() {
      sendUnityEvent('RoomModule', 'ResetAllReceiver');
    },
    resetPosition() {
      sendUnityEvent('RoomModule', 'ResetPositionReceiver');
    },
    resetRotation() {
      sendUnityEvent('RoomModule', 'ResetRotationReceiver');
    },
    resetScale() {
      sendUnityEvent('RoomModule', 'ResetScaleReceiver');
    },
    focusObject({ objectName }) {
      LogCurator('SetFocusOnIndividualObjectReceiver', objectName);
      sendUnityEvent('RoomModule', 'SetFocusOnIndividualObjectReceiver', objectName);
    },
    async ReplaceProp({
      propId,
      objectName,
      selectedProp = [],
      newProp,
      groupPropData = {},
      isLastPropToReplace = false,
    }) {
      const productDbData = await updateDbProp(newProp);
      const lightList = await getPropLightList(newProp);
      const onboardingSelectedProduct = selectSelectedOnboardingProduct(getAppState());
      const { styling_object_name } = onboardingSelectedProduct;
      const isOnboardingState = isUserOnboarding();

      const isReplacingPropByProp = !selectedProp?.[0]?.isGroupSelected && !newProp?.is_prop_group;
      const isReplacingPropByGroupProp =
        !selectedProp?.[0]?.isGroupSelected && newProp?.is_prop_group;
      const isReplacingGroupPropByProp =
        selectedProp?.[0]?.isGroupSelected && !newProp?.is_prop_group;
      const isReplacingGroupPropByGroupProp =
        selectedProp?.[0]?.isGroupSelected && newProp?.is_prop_group;

      const replacePropObj = {
        isLastPropToReplace: isLastPropToReplace,
        ...(isReplacingPropByProp && {
          propIdToReplace: propId,
          objectNameToReplace: objectName,
          propIdToReplaceWith: newProp.id,
          propToReplaceWithLocationUrl: newProp.is_windows_and_doors
            ? productDbData?.file_window_door || newProp.product_file_window_door
            : productDbData?.file || newProp.product_file,
          propName: newProp.name,
          isMatch: !newProp.is_scale,
          roomLightDatas: lightList,
          preDefinedMetadata: newProp.product_meta_info,
          isExclusiveProp: isExclusiveProp(newProp),
          ...(newProp?.prop_data_user_file ? { modelType: 'UserImportModel' } : {}),
        }),
        ...(isReplacingPropByGroupProp && {
          propIdToReplace: propId,
          objectNameToReplace: objectName,
          groupPropData: groupPropData?.finalJson,
          isMatch: !newProp.is_scale,
        }),
        ...(isReplacingGroupPropByProp && {
          propIdToReplaceWith: newProp.id,
          propToReplaceWithLocationUrl: newProp.is_windows_and_doors
            ? productDbData?.file_window_door || newProp.product_file_window_door
            : productDbData?.file || newProp.product_file,
          propName: newProp.name,
          isMatch: !newProp.is_scale,
          roomLightDatas: lightList,
          preDefinedMetadata: newProp.product_meta_info,
          isExclusiveProp: isExclusiveProp(newProp),
          groupId: selectedProp?.[0]?.groupId,
          groupObjectName: selectedProp?.[0]?.groupObjectName,
          ...(newProp?.prop_data_user_file ? { modelType: 'UserImportModel' } : {}),
        }),
        ...(isReplacingGroupPropByGroupProp && {
          groupId: selectedProp?.[0]?.groupId,
          groupObjectName: selectedProp?.[0]?.groupObjectName,
          groupPropData: groupPropData?.finalJson,
          isMatch: !newProp.is_scale,
        }),
      };
      if (isOnboardingState) {
        replacePropObj.styleObjectName = styling_object_name;
      }
      console.warn('replacePropObj', replacePropObj);
      sendUnityEvent('RoomModule', 'ReplaceProp', JSON.stringify(replacePropObj));
    },
    InstantiateGroupProp(prop) {
      LogCurator('send group props data', prop);
      sendUnityEvent('RoomModule', 'InstantiateGroupProp', JSON.stringify(prop));
    },
    InstantiatePropReceiever(prop) {
      LogCurator('send props data', prop);
      if (isMattressBuilderPage()) {
        dispatcher(productBuilderActions.setInstantiatedProps(prop));
      }
      sendUnityEvent('RoomModule', 'InstantiatePropReceiever', JSON.stringify(prop));
    },
    InstantiatePropsReceiever(propList) {
      LogCurator('send props data', propList);
      sendUnityEvent('RoomModule', 'InstantiatePropsReceiever', JSON.stringify(propList));
    },
    CancelDraggableProp() {
      sendUnityEvent('RoomModule', 'CancelDraggableProp');
    },
    addProp(data) {
      console.warn('DEBUG___InstantiatePropFromLibrary', data);
      sendUnityEvent('RoomModule', 'InstantiatePropFromLibrary', JSON.stringify(data));
    },
    GetLoadedConfiguratorInfoReceiver() {
      sendUnityEvent('RoomModule', 'GetLoadedConfiguratorInfoReceiver');
    },
    GetLoadedLifeStyleInfoReceiver() {
      sendUnityEvent('RoomModule', 'GetLoadedLifeStyleInfoReceiver');
    },
    ReplaceDummyObjectWithProp(data) {
      sendUnityEvent('RoomModule', 'ReplaceDummyObjectWithProp', JSON.stringify(data));
    },
    GetRedBullProjectJson() {
      LogCurator('GetRedBullProjectJson');
      sendUnityEvent('RoomModule', 'GetRedBullProjectJson');
    },
    GetObjectDataForDuplicatedRetailPropReceiver() {
      sendUnityEvent('RoomModule', 'GetObjectDataForDuplicatedRetailPropReceiver');
    },
    GetCurrentComponentsReceiver() {
      sendUnityEvent('RoomModule', 'GetCurrentComponentsReceiver');
    },
    ChangeProductTypeReceiver(data) {
      LogCurator('ChangeProductTypeReceiver', data);
      sendUnityEvent('RoomModule', 'ChangeProductTypeReceiver', JSON.stringify(data));
    },
    ChangeHeightProductReceiver(data) {
      LogCurator('ChangeHeightProductReceiver', data);
      sendUnityEvent('RoomModule', 'ChangeHeightProductReceiver', JSON.stringify(data));
    },
    ChangeProductComponentReceiver(data) {
      LogCurator('ChangeProductComponentReceiver', data);
      sendUnityEvent('RoomModule', 'ChangeProductComponentReceiver', JSON.stringify(data));
    },
    AddProductComponentReceiver(data) {
      LogCurator('AddProductComponentReceiver', data);
      sendUnityEvent('RoomModule', 'AddProductComponentReceiver', JSON.stringify(data));
    },
    MirrorTopToBottomReceiver(data) {
      LogCurator('MirrorTopToBottomReceiver', data);
      sendUnityEvent('RoomModule', 'MirrorTopToBottomReceiver', JSON.stringify(data));
    },
    AutomaticPlacementReceiever(data) {
      LogCurator('AutomaticPlacementReceiever', data);
      sendUnityEvent('RoomModule', 'AutomaticPlacementReceiever', JSON.stringify(data));
    },
    ModifyComponentTransformReceiver(data) {
      LogCurator('ModifyComponentTransformReceiver', data);
      sendUnityEvent('RoomModule', 'ModifyComponentTransformReceiver', JSON.stringify(data));
    },
    DeleteProductComponentReceiver(data) {
      LogCurator('DeleteProductComponentReceiver', data);
      sendUnityEvent('RoomModule', 'DeleteProductComponentReceiver', JSON.stringify(data));
    },
    ChangeComponentSideReceiver(data) {
      LogCurator('ChangeComponentSideReceiver', data);
      sendUnityEvent('RoomModule', 'ChangeComponentSideReceiver', JSON.stringify(data));
    },
    ModifyComponentReceiver(data) {
      LogCurator('ModifyComponentReceiver', data);
      sendUnityEvent('RoomModule', 'ModifyComponentReceiver', JSON.stringify(data));
    },
    HandleUserComponentConfirmationReceiver(data) {
      LogCurator('HandleUserComponentConfirmationReceiver', data);
      sendUnityEvent('RoomModule', 'HandleUserComponentConfirmationReceiver', JSON.stringify(data));
    },
    UseCustomDisplacementMapToggleReceiver(data) {
      LogCurator('UseCustomDisplacementMapToggleReceiver');
      sendUnityEvent(
        'MaterialModule',
        'UseCustomDisplacementMapToggleReceiver',
        JSON.stringify(data)
      );
    },
    OnUpdateDisplacementValueReceiver(data) {
      LogCurator('OnUpdateDisplacementValueReceiver', data);
      sendUnityEvent('MaterialModule', 'OnUpdateDisplacementValueReceiver', parseFloat(data));
    },
    ToggleProductBuilderInternalViewReceiver(data) {
      LogCurator('ToggleProductBuilderInternalViewReceiver', data);
      sendUnityEvent(
        'RoomModule',
        'ToggleProductBuilderInternalViewReceiver',
        JSON.stringify(data)
      );
    },
    ChangeLayerSequenceReceiver(data) {
      LogCurator('ChangeLayerSequenceReceiver', data);
      sendUnityEvent('RoomModule', 'ChangeLayerSequenceReceiver', JSON.stringify(data));
    },
    ToggleLockLayerReceiver(data) {
      LogCurator('ToggleLockLayerReceiver', data);
      sendUnityEvent('RoomModule', 'ToggleLockLayerReceiver', JSON.stringify(data));
    },
    HighlightProductBuilderObjectReceiver(data) {
      LogCurator('HighlightProductBuilderObjectReceiver', data);
      sendUnityEvent('RoomModule', 'HighlightProductBuilderObjectReceiver', JSON.stringify(data));
    },
    SavedMaterialDataReceiver(data) {
      sendUnityEvent('RoomModule', 'SavedMaterialDataReceiver');
    },
    DeleteComponentOnKeyPressReceiver(data) {
      LogCurator('DeleteComponentOnKeyPressReceiver', data);
      sendUnityEvent('RoomModule', 'DeleteComponentOnKeyPressReceiver', JSON.stringify(data));
    },
    ChangeCameraNearClipPlane(data) {
      LogCurator('ChangeCameraNearClipPlane', parseFloat(data));
      sendUnityEvent('RoomModule', 'ChangeCameraNearClipPlane', parseFloat(data));
    }
  };

  window.CancelDraggableProp = roomModule.CancelDraggableProp;

  const projectModule = {
    ApplyMaterialReceiver(materailData) {
      LogCurator('ApplyMaterialReceiver', materailData);
      sendUnityEvent('ProjectModule', 'ApplyMaterialReceiver', JSON.stringify(materailData));
    },
  };

  const cameraModule = {
    OnSelectDepthOfFieldReceiver(enabled) {
      sendUnityEvent('CameraModule', 'OnSelectDepthOfFieldReceiver', booleanToText(enabled));
      dispatcher(setObjectSelectionActive(enabled));
    },
    OnCameraVerticalTiltReceiver(enabled) {
      sendUnityEvent('CameraModule', 'OnCameraVerticalTiltReceiver', booleanToText(enabled));
    },
    UpdateCameraHeightReceiver(height) {
      sendUnityEvent('CameraModule', 'UpdateCameraHeightReceiver', height);
    },
    OnUpdateCameraFovReceiver(fovVale) {
      sendUnityEvent('CameraModule', 'OnUpdateCameraFovReceiver', fovVale);
    },
    OnUpdateDepthOfFieldValueReceiver(intensity) {
      // update blur intensity
      sendUnityEvent('CameraModule', 'OnUpdateDepthOfFieldValueReceiver', intensity);
    },

    OnSelectFocusObjectReceiver() {
      sendUnityEvent('CameraModule', 'OnSelectFocusObjectReceiver');
    },
    ClearSelectedObjectReceiver() {
      sendUnityEvent('CameraModule', 'ClearSelectedObjectReceiver');
      dispatcher(setObjectSelectionActive(true));
    },
    importPredefinedCameraFromPresets(cameraList) {
      // const unityCameraList = cameraList.map(convertCameraToUnityModel);
      const canvasSize = selectCanvasSize(getAppState());
      const unityCameraList = cameraList.map((camera) => {
        return {
          ...camera,
          canvas_width: canvasSize.width,
          canvas_height: canvasSize.height,
        };
      });

      sendUnityEvent(
        'CameraModule',
        'OnImportPrefinedCamAsNormalCamReceiver',
        JSON.stringify(unityCameraList)
      );
    },
    OnUpdateCameraResoYReceiver(resoY) {
      LogCurator('OnUpdateCameraResoYReceiver', resoY);
      sendUnityEvent('CameraModule', 'OnUpdateCameraResoYReceiver', resoY);
    },
    OnUpdateCameraResoXReceiver(resoX) {
      LogCurator('OnUpdateCameraResoXReceiver', resoX);
      sendUnityEvent('CameraModule', 'OnUpdateCameraResoXReceiver', resoX);
    },
    UpdateCameraResolutionReceiver({ resoX, resoY }) {
      LogCurator('UpdateCameraResolutionReceiver', { resoX, resoY });
      sendUnityEvent(
        'CameraModule',
        'UpdateCameraResolutionReceiver',
        JSON.stringify({ resoX, resoY })
      );
    },
    CloseFocusObjectReceiver() {
      LogCurator('CloseFocusObjectReceiver');
      sendUnityEvent('CameraModule', 'CloseFocusObjectReceiver');
    },
    OnUpdateLockReceiver(lock) {
      sendUnityEvent('CameraModule', 'OnUpdateLockReceiver', booleanToText(lock));
    },
    GetCurrentCameraScreenshotReceiver() {
      sendUnityEvent('CameraModule', 'GetCurrentCameraScreenshotReceiver');
    },
    SetFocusObjectReceiver({ blurIntensity, focusXPos, focusYPos, focusZPos }) {
      sendUnityEvent(
        'CameraModule',
        'SetFocusObjectReceiver',
        JSON.stringify({
          blurIntensity,
          focusXPos,
          focusYPos,
          focusZPos,
        })
      );
    },
    OnUpdateCameraMoveSpeed(speed) {
      sendUnityEvent('CameraModule', 'OnUpdateCameraMoveSpeed', speed);
    },
    OnUpdateCameraZoomSpeed(speed) {
      sendUnityEvent('CameraModule', 'OnUpdateCameraZoomSpeed', speed);
    },
    CurrentViewCameraAngleReceiver() {
      sendUnityEvent('CameraModule', 'CurrentViewCameraAngleReceiver');
    },
    TurnOffDepthOfFieldReceiver() {
      sendUnityEvent('CameraModule', 'TurnOffDepthOfFieldReceiver');
    },
    GetCanvasSizeReceiver({ canvas_width, canvas_height }) {
      sendUnityEvent(
        'CameraModule',
        'GetCanvasSizeReceiver',
        JSON.stringify({
          canvas_width,
          canvas_height,
        })
      );
    },
    OnChangeSafeFrameResolutionReceiver({
      safeFrameWidth,
      safeFrameHeight,
      canvas_width,
      canvas_height,
    }) {
      if (!safeFrameWidth || !safeFrameHeight) return;

      sendUnityEvent(
        'CameraModule',
        'OnChangeSafeFrameResolutionReceiver',
        JSON.stringify({
          safeFrameWidth,
          safeFrameHeight,
          canvas_width,
          canvas_height,
        })
      );
    },
    changeSafeFrameResolution({ cameraWidth, cameraHeight }) {
      const canvasSize = selectCanvasSize(getAppState());
      const safeFrameSize = calculateSafeFrameSize({
        cameraHeight,
        cameraWidth,
      });
      this.OnChangeSafeFrameResolutionReceiver({
        safeFrameWidth: safeFrameSize.width,
        safeFrameHeight: safeFrameSize.height,
        canvas_width: canvasSize.width,
        canvas_height: canvasSize.height,
      });
    },
  };

  const mainController = {
    SetTransformation(transformData) {
      sendUnityEvent('MainController', 'SetTransformation', JSON.stringify(transformData));
    },
    SetMutlipleTransforms(transformData) {
      sendUnityEvent('MainController', 'SetMutlipleTransforms', JSON.stringify(transformData));
    },
    EnableGameObject(unityObjectData) {
      LogCurator('EnableGameObject', unityObjectData);
      sendUnityEvent('MainController', 'EnableGameObject', JSON.stringify(unityObjectData));
    },
    DisableGameObject(config) {
      LogCurator('DisableGameObject', config);
      sendUnityEvent('MainController', 'DisableGameObject', JSON.stringify(config));
    },
    SelectObjectReceiver(objectList) {
      LogCurator('SelectObjectReceiver', objectList);
      sendUnityEvent('MainController', 'SelectObjectReceiver', JSON.stringify(objectList));
    },
    SelectProductObjectReceiver(objectList) {
      console.warn('SelectProductObjectReceiver appliedPatDataFromUnity', objectList);
      sendUnityEvent('MainController', 'SelectProductObjectReceiver', JSON.stringify(objectList));
    },
    MousePointerReceiver(active) {
      sendUnityEvent('MainController', 'MousePointerReceiver', booleanToText(active));
    },
    ReInstantiateDuplicateObjects(objectList) {
      LogCurator('ReInstantiateDuplicateObjects', objectList);
      sendUnityEvent('MainController', 'ReInstantiateDuplicateObjects', JSON.stringify(objectList));
    },
    ToggleDebuggerModeReciever(active) {
      sendUnityEvent('MainController', 'ToggleDebuggerModeReciever', booleanToText(active));
    },
    ResetPropMaterials() {
      sendUnityEvent('MainController', 'ResetPropMaterials');
    },
  };

  const settingsController = {
    ToggleAutoFocus(active) {
      LogCurator('ToggleAutoFocus', active);
      sendUnityEvent('SettingsModule', 'ToggleAutoFocus', booleanToText(active));
    },
  };

  const floorPanelController = {
    OnSelectPatternReceiver(data) {
      LogCurator('GenerateWithDataWithJson', data);
      sendUnityEvent('FloorPannerController', 'GenerateWithDataWithJson', JSON.stringify(data));
    },
    OnUploadNormalMap() {
      LogCurator('UploadNormalMap');
      sendUnityEvent('FloorPannerController', 'UploadNormalMap');
    },
    OnUploadAlbedoMap() {
      LogCurator('UploadAlbedoMap');
      sendUnityEvent('FloorPannerController', 'UploadAlbedoMap');
    },
    OnUploadRoughnessMap() {
      LogCurator('UploadRoughnessMap');
      sendUnityEvent('FloorPannerController', 'UploadRoughnessMap');
    },
    OnUploadMetallicMap() {
      LogCurator('UploadMettalicMap');
      sendUnityEvent('FloorPannerController', 'UploadMettalicMap');
    },

    OnChangeNormalDepthValue(data) {
      LogCurator('ChangeNormalDepthValue', data);
      sendUnityEvent('FloorPannerController', 'ChangeNormalDepthValue', data);
    },
    OnResetUnityWindow() {
      LogCurator('ResetMaterialOnPanelClose');
      sendUnityEvent('FloorPannerController', 'ResetMaterialOnPanelClose');
    },
    OnUploadTiling() {
      LogCurator('GetTiling');
      sendUnityEvent('FloorPannerController', 'GetTiling');
    },
    OnSendInitialData(data) {
      LogCurator('CacheInitialTexture', data);
      sendUnityEvent('FloorPannerController', 'CacheInitialTexture', data);
    },
    GetGeneratedTextureSize(data) {
      LogCurator('GetGeneratedTextureSize', data);
      sendUnityEvent('FloorPannerController', 'GetGeneratedTextureSize', data);
    },
    OnSelectGlossyMetallic(data) {
      LogCurator('GenerateBlackAndWhiteMapWithJson', data);
      sendUnityEvent(
        'FloorPannerController',
        'GenerateBlackAndWhiteMapWithJson',
        JSON.stringify(data)
      );
    },
    ApplyOnRenderer(data) {
      LogCurator('ApplyOnRenderer', data);
      sendUnityEvent('FloorPannerController', 'ApplyOnRenderer', data);
    },
    GetResizeTexture(data) {
      LogCurator('GetResizedTexture', data);
      sendUnityEvent('OpenCVReactCommunicator', 'GetResizedTexture', data);
    },

    async selectPattern({ patternData }) {
      try {
        this.OnSelectPatternReceiver(patternData);
      } catch (error) {
        //captureException(error);
        console.error(error);
        return false;
      }
      return true;
    },

    async changeDepthValue(value) {
      try {
        this.OnChangeNormalDepthValue(value);
      } catch (error) {
        //captureException(error);
        console.error(error);
        return false;
      }
      return true;
    },
    async sendInitailDataToUnity(value) {
      try {
        this.OnSendInitialData(value);
      } catch (error) {
        //captureException(error);
        console.error(error);
        return false;
      }
      return true;
    },

    async callGlossyMetallicEvent(data) {
      try {
        this.OnSelectGlossyMetallic(data);
      } catch (error) {
        //captureException(error);
        console.error(error);
        return false;
      }
      return true;
    },
  };

  const handleGroupPropsLoad = async (
    product,
    x,
    y,
    { openProductsAfterPlacement = false } = {}
  ) => {
    try {
      clearUI();
      roomModule.CancelDraggableProp();
      dispatch(setUnityDraggableProductData(null));
      dispatch(setOpenProductsAfterPlacement(openProductsAfterPlacement));
      setDraggablePropLoading(true);
      dispatch(
        setDraggableProductImage({
          id: product.id,
          image:
            product.thumbnail || product.prop_group_list?.[0]?.thumbnail || THUMBNAIL_PLACEHOLDER,
          x,
          y,
        })
      );

      const productDbData = await Promise.all(
        product.prop_group_list.map(async (a, i) => {
          const loadingProgress = paginatedProductSelectors.selectItemProgress(
            getAppState(),
            product.id
          );

          const prop = await updateDbProp(a, {
            assetFetchFunc: async ({ file }) => {
              const response = await axios({
                method: 'GET',
                url: file,
                responseType: 'blob',
                onDownloadProgress: (event) => {
                  // LogCurator('Curator', event);
                  // if (event.type === 'progress') {
                  //   dispatch(
                  //     paginatedProductActions.setProgress({
                  //       id: product.id,
                  //       total: event.total,
                  //       loaded: event.loaded,
                  //     })
                  //   );
                  // }
                },
              });

              if (!response?.data) {
                dispatch(
                  paginatedProductActions.setProgress({
                    ...loadingProgress,
                    id: product.id,
                    loaded: loadingProgress?.loaded || 0 + 1,
                  })
                );
                throw new Error('Unable download prop');
              }

              return response?.data;
            },
          });

          console.log('CURATOR loadingProgress', loadingProgress);
          dispatch(
            paginatedProductActions.setProgress({
              ...loadingProgress,
              id: product.id,
              loaded: loadingProgress?.loaded || 0 + 1,
            })
          );

          return prop;
        })
      );
      const lightList = (
        await Promise.all(product.prop_group_list.map(async (a) => await getPropLightList(a)))
      ).reduce((acc, curr) => {
        acc.push(...curr);
        return acc;
      }, []);

      const data = {
        type: 'PropLibrary',
        id: product.id,
        propName: product.name,
        locationUrl: productDbData?.file || product.product_file,
        isRoofProp: productDbData?.is_roof_prop,
        preDefinedMetadata: product.product_meta_info,
        roomLightDatas: lightList,
        isExclusiveProp: isExclusiveProp(product),
        isGroupProp: true,
      };

      dispatch(setUnityDraggableProductData(data));

      //  sendUnityEvent("RoomModule", "InstantiatePropReciever", JSON.stringify(data));
    } catch (e) {
      //captureException(e);
      console.error(e);
      errorToast('Error happened while loading product');
      cancelDraggablePropUI();
    } finally {
      // setDraggablePropLoading(false);
    }
  };

  const handlePropsLoad = async (product, x, y, { openProductsAfterPlacement = false } = {}) => {
    try {
      clearUI();
      roomModule.CancelDraggableProp();
      dispatch(setUnityDraggableProductData(null));
      dispatch(setOpenProductsAfterPlacement(openProductsAfterPlacement));
      setDraggablePropLoading(true);
      dispatch(
        setDraggableProductImage({
          id: product.id,
          image: product.thumbnail || THUMBNAIL_PLACEHOLDER,
          x,
          y,
        })
      );
      const productDbData = await updateDbProp(product, {
        assetFetchFunc: async ({ file, file_window_door, is_windows_and_doors = false }) => {
          const response = await axios({
            method: 'GET',
            url: is_windows_and_doors ? file_window_door : file,
            responseType: 'blob',
            onDownloadProgress: (event) => {
              LogCurator('Curator', event);
              if (event.type === 'progress' && !is_windows_and_doors) {
                dispatch(
                  paginatedProductActions.setProgress({
                    id: product.id,
                    total: event.total,
                    loaded: event.loaded,
                  })
                );
              }
            },
          });

          if (!response?.data) {
            throw new Error('Unable download prop');
          }

          return response?.data;
        },
      });
      const lightList = await getPropLightList(product);
      const hasGroupId =
        product?.groupId !== null &&
        product?.groupId !== undefined &&
        `${product?.groupId}`.trim() !== '';

      const data = {
        type: 'PropLibrary',
        id: product.id,
        ...(hasGroupId ? { groupId: product?.groupId } : {}),
        propName: product.name,
        locationUrl: product.is_windows_and_doors
          ? productDbData?.file_window_door || product.product_file_window_door
          : productDbData?.file || product.product_file,
        preDefinedMetadata: product.product_meta_info,
        isRoofProp: productDbData?.is_roof_prop,
        roomLightDatas: lightList,
        isExclusiveProp: isExclusiveProp(product),
        modelType: hasGroupId || product?.prop_data_user_file ? 'UserImportModel' : '',
      };

      dispatch(setUnityDraggableProductData(data));

      //  sendUnityEvent("RoomModule", "InstantiatePropReciever", JSON.stringify(data));
    } catch (e) {
      //captureException(e);
      console.error(e);
      errorToast('Error happened while loading product');
      cancelDraggablePropUI();
    } finally {
      setDraggablePropLoading(false);
    }
  };

  const retailAutomationModule = {
    GetListOfPropsLoadedInRack(objectName) {
      sendUnityEvent('RetailAutomation', 'GetListOfPropsLoadedInRack', objectName);
    },
    FocusProduct(objectName) {
      sendUnityEvent('RetailAutomation', 'FocusAutomationObjectReceiver', objectName);
    },
    SelectedVariationProp(objectName) {
      sendUnityEvent('RetailAutomation', 'SelectedVariationProp', objectName);
    },
    GetHotSpotLinkedPropData(objectName) {
      sendUnityEvent('RetailAutomation', 'GetHotSpotLinkedPropData', objectName);
    },
    DisableHotSpotLinkedProp(objectName) {
      sendUnityEvent('RetailAutomation', 'DisableHotSpotLinkedProp', objectName);
    },
    SetMaterialPropertiesOnGivenMaterialName(data) {
      LogCurator('SetMaterialPropertiesOnGivenMaterialName', data);
      sendUnityEvent(
        'MaterialModule',
        'SetMaterialPropertiesOnGivenMaterialName',
        JSON.stringify(data)
      );
    },
    SetMaterialPropertiesOnGivenMaterialNames(data) {
      LogCurator('SetMaterialPropertiesOnGivenMaterialNames', data);
      sendUnityEvent(
        'MaterialModule',
        'SetMaterialPropertiesOnGivenMaterialNames',
        JSON.stringify(data)
      );
    },
    SelectMaterialUsingMaterialNameForRetailAutomation(materialName, otherData) {
      LogCurator('SelectMaterialUsingMaterialNameForRetailAutomation', { materialName, otherData });
      sendUnityEvent(
        'MaterialModule',
        'SelectMaterialUsingMaterialNameForRetailAutomation',
        materialName
      );
    },
    GetDefaultMaterialDataByMaterialNameForRetailAutomation(data) {
      LogCurator('GetDefaultMaterialDataByMaterialNameForRetailAutomation', data);
      sendUnityEvent(
        'MaterialModule',
        'GetDefaultMaterialDataByMaterialNameForRetailAutomation',
        JSON.stringify(data)
      );
    },
    SendBase64DiffuseImageDataByMaterialNameForRetailAutomationReceiver(materialName) {
      LogCurator(
        'SendBase64DiffuseImageDataByMaterialNameForRetailAutomationReceiver',
        materialName
      );
      sendUnityEvent(
        'MaterialModule',
        'SendBase64DiffuseImageDataByMaterialNameForRetailAutomationReceiver',
        materialName
      );
    },
    BreakMaterialOfSelectedObjects() {
      sendUnityEvent('MaterialModule', 'BreakMaterialOfSelectedObjects');
    },
    RemoveVariationProp(data) {
      sendUnityEvent('RetailAutomation', 'RemoveVariationProp', data);
    },
    SelectShelfReceiever(data) {
      sendUnityEvent('RetailAutomation', 'SelectShelfReceiever', JSON.stringify(data));
    },
    EmptySelectedShelfReceiever(data) {
      sendUnityEvent('RetailAutomation', 'EmptySelectedShelfReceiever', JSON.stringify(data));
    },
    AddToCustomizationObjectListReceiver(data) {
      sendUnityEvent('RetailAutomation', 'AddToCustomizationObjectListReceiver', data);
    },
    CheckSelectedShelfIsEmptyReceiever(data) {
      sendUnityEvent(
        'RetailAutomation',
        'CheckSelectedShelfIsEmptyReceiever',
        JSON.stringify(data)
      );
    },
    ResetRetailAutomationReceiver() {
      dispatch(setRoomLoadedCompletely(false));
      sendUnityEvent('RetailAutomation', 'ResetRetailAutomationReceiver');
    },
    CheckRackIsEmptyReceiever() {
      sendUnityEvent('RetailAutomation', 'CheckRackIsEmptyReceiever');
    },
    EmptyRackReceiver() {
      sendUnityEvent('RetailAutomation', 'EmptyRackReceiver');
    },
  };

  const productBuilderModule = {
    ApplyDefaultTextureDataForProductBuilder(data) {
      LogCurator('ApplyDefaultTextureDataForProductBuilder', data);
      sendUnityEvent('ProductBuilderModule', 'ApplyDefaultTextureDataForProductBuilder', JSON.stringify(data));
    },
    AddButtonReceiver(data) {
      LogCurator('AddButtonReceiver', data);
      sendUnityEvent('ProductBuilderModule', 'AddButtonReceiver', JSON.stringify(data));
    },
    ChangeProductComponentReceiver(data) {
      LogCurator('ChangeProductComponentReceiver', data);
      sendUnityEvent('ProductBuilderModule', 'ChangeProductComponentReceiver', JSON.stringify(data));
    },
    ChangeButtonConfiguration(data) {
      LogCurator('ChangeButtonConfiguration', data);
      sendUnityEvent('ProductBuilderModule', 'ChangeButtonConfiguration', JSON.stringify(data));
    },
    DeleteTuftButtonConfiguration (data) {
      LogCurator('DeleteTuftButtonConfiguration', data);
      sendUnityEvent('ProductBuilderModule', 'DeleteTuftButtonConfiguration', JSON.stringify(data));
    },
    FocusOnButtonConfigurationReceiver (data) {
      LogCurator('FocusOnButtonConfigurationReceiver', data);
      sendUnityEvent('ProductBuilderModule', 'FocusOnButtonConfigurationReceiver', JSON.stringify(data));
    },
    ArrangeTuftButtonReceiverOnInternalLayerChange () {
      LogCurator('ArrangeTuftButtonReceiverOnInternalLayerChange');
      sendUnityEvent('ProductBuilderModule', 'ArrangeTuftButtonReceiverOnInternalLayerChange');
    },
    OnArrangeTufftedButtonReceiver (data) {
      LogCurator('OnArrangeTufftedButtonReceiver', data);
      sendUnityEvent('ProductBuilderModule', 'OnArrangeTufftedButtonReceiver', JSON.stringify(data));
    },
    SnapButtonsToParentObject () {
      LogCurator('SnapButtonsToParentObject');
      sendUnityEvent('ProductBuilderModule', 'SnapButtonsToParentObject');
    },
    DisableButtonMeshRendererReceiver (data) {
      LogCurator('DisableButtonMeshRendererReceiver');
      sendUnityEvent('ProductBuilderModule', 'DisableButtonMeshRendererReceiver', JSON.stringify(data));
    },
    GetPresetConfiguration (data) {
      LogCurator('GetPresetConfiguration', data);
      sendUnityEvent('ProductBuilderModule', 'GetPresetConfiguration', JSON.stringify(data));
    },
    EnableGameObject(data) {
      LogCurator('EnableGameObject PBM', data);
      sendUnityEvent('ProductBuilderModule', 'EnableGameObject', JSON.stringify(data));
    },
    DisableGameObject(data) {
      LogCurator('DisableGameObject PBM', data);
      sendUnityEvent('ProductBuilderModule', 'DisableGameObject', JSON.stringify(data));
    },
  }

  window.retailAutomationModule = retailAutomationModule;
  window.productBuilderModule = productBuilderModule;
  window.roomModule = roomModule;
  window.metadataModule = metadataModule;
  window.automationModule = automationModule;
  window.DisableLogInUnity = (enabled) => {
    sendUnityEvent('MainController', 'DisableLogInUnity', JSON.stringify(enabled));
  };

  const contextValue = {
    unityTigg,
    handleMovement,
    handleLoad,
    handleLoadProject,
    unityContext,
    handlePropsLoad,
    handleGroupPropsLoad,
    handleSelectedCamera,
    handleCreateCamera,
    handleCameraFov,
    handleCameraCorrection,
    handleCameraHeight,
    handleDepthOfField,
    handleBlurIntensity,
    handleCameraScreenshot,
    handleCameraPopupClose,
    handleGraphicQualityChange,
    handleVerticalRotationSpeed,
    handleHorizontalRotationSpeed,
    handleMeasureUnitChange,
    materialModule,
    metadataModule,
    automationModule,
    lightModule,
    shortcutsModule,
    roomModule,
    projectModule,
    cameraModule,
    mainController,
    settingsController,
    floorPanelController,
    propertiesScrollableElementId: 'CuratorSidebarLayoutScrollableContainer_style',
    setDataNotSaved: setCuratorNotSaved,
    alignmentModule,
    retailAutomationModule,
    handleLoadProjectBuilder,
    sentryUnityModule,
    productBuilderModule
  };

  window.unityContext = {
    ...contextValue,
    unityContext,
  };

  return <unitycontext.Provider value={contextValue}>{children}</unitycontext.Provider>;
}

export const useUnityContext = () => useContext(unitycontext);

export default UnityContainer;
